import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { N07CorporateFooterProps } from './N07CorporateFooter.types';
import { CorporateFooter } from '@ahc-digital/component-library';
import { CreateCorporatefooterModel } from './N07CorporateFooter.service';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: N07CorporateFooterProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  return (
    <CorporateFooter
      data-component={marketingRenderingName}
      {...CreateCorporatefooterModel(props)}
    />
  );
};
